import BatchOperation from './src/main'

BatchOperation.install = function (Vue) {
    Vue.component(BatchOperation.name, BatchOperation)
}

export default BatchOperation